export interface JwtPayload {
  exp?: number;
  iat?: number;
  sub?: string;
  [key: string]: unknown;
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload) as JwtPayload;
  } catch {
    return null;
  }
}

export function getJwtExpirationSeconds(token: string): number | null {
  const payload = decodeJwtPayload(token);
  return typeof payload?.exp === 'number' ? payload.exp : null;
}

export function isJwtExpired(token: string, skewSeconds = 30): boolean {
  const exp = getJwtExpirationSeconds(token);
  if (exp == null) return false;
  return exp <= Math.floor(Date.now() / 1000) + skewSeconds;
}

export function getJwtSecondsUntilExpiry(token: string): number | null {
  const exp = getJwtExpirationSeconds(token);
  if (exp == null) return null;
  return exp - Math.floor(Date.now() / 1000);
}

export function isJwtExpiringSoon(token: string, withinSeconds: number): boolean {
  const remaining = getJwtSecondsUntilExpiry(token);
  if (remaining == null) return false;
  return remaining > 0 && remaining <= withinSeconds;
}
